import { EMPTY_EFFECT } from '../../preset-util/base-preset-util';

import DrawerClose0Dy from './drawer-icon/close_0_dy.svg';
import DrawerClose4Dy from './drawer-icon/close_4_dy.svg';
import DrawerClose8Dy from './drawer-icon/close_8_dy.svg';
import DrawerEMPTY from './drawer-icon/empty.svg';

import NoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/no_effect_fill_44.svg';
import ImageVariantTightImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_tight_image_contact_fill_44.svg';
import ImageVariantHalfImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_half_image_contact_fill_44.svg';
import ImageVariantFullImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_full_image_contact_fill_44.svg';
import ImageVariantTightImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_tight_image_4pt_offset_fill_44.svg';
import ImageVariantHalfImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_half_image_4pt_offset_fill_44.svg';
import ImageVariantFullImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_full_image_4pt_offset_fill_44.svg';
import ImageVariantTightImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_tight_image_8pt_offset_fill_44.svg';
import ImageVariantHalfImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_half_image_8pt_offset_fill_44.svg';
import ImageVariantFullImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/image_variant_full_image_8pt_offset_fill_44.svg';


import ShapeNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_noeffect_44.svg';
import ShapeVariantTightImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_tightimage_contact_44.svg';
import ShapeVariantHalfImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_halfimage_contact_44.svg';
import ShapeVariantFullImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_fullimage_contact_44.svg';
import ShapeVariantTightImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_tightimage_4ptoffset_44.svg';
import ShapeVariantHalfImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_halfimage_4ptoffset_44.svg';
import ShapeVariantFullImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_fullimage_4ptoffset_44.svg';
import ShapeVariantTightImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_tightimage_8ptoffset_44.svg';
import ShapeVariantHalfImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_halfimage_8ptoffset_44.svg';
import ShapeVariantFullImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_imagevariant_fullimage_8ptoffset_44.svg';

import TextNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/text_noeffect_44.svg';
import TextVariantTightImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_tightimage_contact_44.svg';
import TextVariantHalfImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_halfimage_contact_44.svg';
import TextVariantFullImageContactFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_fullimage_contact_44.svg';
import TextVariantTightImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_tightimage_4ptoffset_44.svg';
import TextVariantHalfImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_halfimage_4ptoffset_44.svg';
import TextVariantFullImage4ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_fullimage_4ptoffset_44.svg';
import TextVariantTightImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_tightimage_8ptoffset_44.svg';
import TextVariantHalfImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_halfimage_8ptoffset_44.svg';
import TextVariantFullImage8ptOffsetFill from '@tencent/docs-design-resources/icon/desktop/svg/text_imagevariant_fullimage_8ptoffset_44.svg';

export {
    DrawerClose0Dy,
    DrawerClose4Dy,
    DrawerClose8Dy,
    DrawerEMPTY,
};

export const IMAGE_PRESET_ICONS = {
    [EMPTY_EFFECT]: NoEffectFill,
    'close-0-dy': ImageVariantTightImageContactFill,
    'close-4-dy': ImageVariantTightImage4ptOffsetFill,
    'close-8-dy': ImageVariantTightImage8ptOffsetFill,
    'half-0-dy': ImageVariantHalfImageContactFill,
    'half-4-dy': ImageVariantHalfImage4ptOffsetFill,
    'half-8-dy': ImageVariantHalfImage8ptOffsetFill,
    'full-0-dy': ImageVariantFullImageContactFill,
    'full-4-dy': ImageVariantFullImage4ptOffsetFill,
    'full-8-dy': ImageVariantFullImage8ptOffsetFill,
};

export const SHAPE_PRESET_ICONS = {
    [EMPTY_EFFECT]: ShapeNoEffectFill,
    'close-0-dy': ShapeVariantTightImageContactFill,
    'close-4-dy': ShapeVariantTightImage4ptOffsetFill,
    'close-8-dy': ShapeVariantTightImage8ptOffsetFill,
    'half-0-dy': ShapeVariantHalfImageContactFill,
    'half-4-dy': ShapeVariantHalfImage4ptOffsetFill,
    'half-8-dy': ShapeVariantHalfImage8ptOffsetFill,
    'full-0-dy': ShapeVariantFullImageContactFill,
    'full-4-dy': ShapeVariantFullImage4ptOffsetFill,
    'full-8-dy': ShapeVariantFullImage8ptOffsetFill,
};

export const TEXT_PRESET_ICONS = {
    [EMPTY_EFFECT]: TextNoEffectFill,
    'close-0-dy': TextVariantTightImageContactFill,
    'close-4-dy': TextVariantTightImage4ptOffsetFill,
    'close-8-dy': TextVariantTightImage8ptOffsetFill,
    'half-0-dy': TextVariantHalfImageContactFill,
    'half-4-dy': TextVariantHalfImage4ptOffsetFill,
    'half-8-dy': TextVariantHalfImage8ptOffsetFill,
    'full-0-dy': TextVariantFullImageContactFill,
    'full-4-dy': TextVariantFullImage4ptOffsetFill,
    'full-8-dy': TextVariantFullImage8ptOffsetFill,
};
